/**
 * Composable for handling whether or not a sticky element is being scrolled, or if they are in there original position
 */
/* UTILS */
import { onBeforeUnmount, ref } from 'vue';
import { useRoute } from 'vue-router';

/* SCROLL STATE OF PAGES */
export const disableNextScroll = ref(false);

export function useIsScrolled(element, offset = 0) {
  /* REF */
  const isScrolled = ref(false);

  /* FUNCTIONS */
  // Callback function called on scroll to toggle the scroll state
  function setIsScrolled() {
    const stickyElement = document.querySelector(element);
    const stickyOffset = stickyElement.getBoundingClientRect().top;
    if (stickyOffset <= offset) {
      isScrolled.value = true;
    } else {
      isScrolled.value = false;
    }
  }

  window.addEventListener('scroll', setIsScrolled);

  /* LIFECYCLES */
  // When component is unmounted, remove event listener
  onBeforeUnmount(() => {
    window.removeEventListener('scroll', setIsScrolled);
  });

  return { isScrolled };
}

/**
 * Scroll behavior on navigation
 */
export function useScrollControl() {
  const route = useRoute();

  const setDisableScroll = (value: boolean) => {
    disableNextScroll.value = value;
  };

  const shouldScroll = () => {
    // Do not scrollTop in network
    const isNetworkWithModal = route.name === 'network';

    const result = !disableNextScroll.value && !isNetworkWithModal;
    disableNextScroll.value = false;
    return result;
  };

  return {
    setDisableScroll,
    shouldScroll
  };
}
